<!-- <form>
    <div class="searchBox_container" [ngClass]="isSearchOpen ? 'showSearch' : ''">
        <span class="icon-search" (click)="searchOpen('open')"></span>
        <div class="search" [ngClass]="isKeyPress ? 'keyPress' : ''">
            <div class="searchWrap">
                <div class="searchIcon back" (click)="searchOpen(null)">
                    <span class="icon-backarrow"></span>
                </div>
                <mat-form-field  appearance="outline" [ngClass]="isSearchOpen?'show':'hideDropdown'"> 
                    <input matInput #SearchInput placeholder="Search" (focus)="onFocusEvent()" />
                    <mat-autocomplete #auto="matAutocomplete" class="searchDropdown">
                        <mat-option [value]="">
                            <span [innerHTML]=""></span>
                        </mat-option>
                    </mat-autocomplete>
                    <div class="searchIcon clear" (click)="SearchInput.value='';">
                        <span class="icon-close"></span>
                    </div>
                    <div class="searchIcon enter">
                        <span class="icon-search"></span>
                    </div>
                </mat-form-field>
            </div>
        </div>
    </div>
</form> -->

<form>
    <div class="searchBox_container" [ngClass]="isSearchOpen ? 'showSearch' : ''">
        <span class="" (click)="searchOpen('open')"></span>
        <div class="search" [ngClass]="isKeyPress ? 'keyPress' : ''">
            <div class="searchWrap">
                <!-- <div class="searchIcon back" (click)="searchOpen(null)">
                    <span class="icon-backarrow"></span>
                </div> -->
  
                    <span class="searchIcon icon-search"></span>

                <div class="searchInput">
                    <input matInput #SearchInput placeholder="Search" (focus)="onFocusEvent()" />
                </div>
                <!-- <mat-form-field class="searchInput" appearance="outline" [ngClass]="isSearchOpen?'show':'hideDropdown'"> 
                    <input matInput #SearchInput placeholder="Search" (focus)="onFocusEvent()" />
                </mat-form-field> -->
                <div class="clearIcon" (click)="SearchInput.value='';">
                    <span class="icon-close"></span>
                </div>
            </div>
        </div>
    </div>
</form>